import { render, staticRenderFns } from "./ButtonColumn.vue?vue&type=template&id=f0ee4af0&scoped=true&"
import script from "./ButtonColumn.vue?vue&type=script&lang=js&"
export * from "./ButtonColumn.vue?vue&type=script&lang=js&"
import style0 from "./ButtonColumn.vue?vue&type=style&index=0&id=f0ee4af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ee4af0",
  null
  
)

export default component.exports